import { render, staticRenderFns } from "./AllUploadBatches.vue?vue&type=template&id=b87b369e"
import script from "./AllUploadBatches.vue?vue&type=script&lang=js"
export * from "./AllUploadBatches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports